/**
 * ============================================================================
 * EXPERIMENT: Calendly Integration (ab_calendly)
 * PR: #TODO_AFTER_PR_CREATION_ab_calendly
 *
 * React Query hooks for Calendly data fetching.
 * Temporary code — will be REMOVED when the experiment concludes.
 *
 * Find all experiment code: grep -r "ab_calendly" src/
 * ============================================================================
 */

import { useQuery } from '@tanstack/react-query';

import { isConnected } from './AB_calendly-auth';
import { fetchCurrentUser, fetchScheduledEvents } from './AB_calendly-api';

const getCalendlyUserQueryKey = () => ['ab_calendly', 'user'] as const;
const getCalendlyEventsQueryKey = (userUri: string) => ['ab_calendly', 'events', userUri] as const;
export function useCalendlyUser() {
    return useQuery({
        queryKey: getCalendlyUserQueryKey(),
        queryFn: fetchCurrentUser,
        enabled: isConnected(),
        staleTime: 5 * 60 * 1000,
    });
}

export function useCalendlyEvents(userUri: string | undefined) {
    return useQuery({
        queryKey: getCalendlyEventsQueryKey(userUri ?? ''),
        queryFn: () => fetchScheduledEvents(userUri!),
        enabled: !!userUri,
        staleTime: 60 * 1000,
    });
}
